import { Col, Drawer, Menu, Row } from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  ACCESS_TOKEN,
  APP_LANGUAGE,
  HELP_MENU,
  MESSENGER_URL,
  PHONE_CONTACT,
  POLICY,
  ROUTER_PATH,
  // WEBSITE_KYMDAN_STORE,
} from "../../common/constant";
import { getMatchingRoute, localizeRouteKey } from "../../shared/helpers";
import SearchBar from "../searchBar";
import _ from "lodash";
import { signOut } from "../../redux/reducers/slice/auth";
import { selectHeaderCategories } from "../../redux/reducers/slice/common";

const { SubMenu } = Menu;

const HamburgerContent = (props: any, ref: any) => {
  useImperativeHandle(ref, () => ({
    toggleModal,
  }));
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const headerCategories = useSelector(selectHeaderCategories);
  const dispatch = useDispatch();
  const { handleClickHamburger, history } = props;
  const [visible, setVisible] = useState(false);
  const [selectedKey, setSelectedKey] = useState("");

  const token = localStorage.getItem(ACCESS_TOKEN);

  useEffect(() => {
    const words = history.location.pathname.split("/");
    setSelectedKey("/" + words[words.length - 1]);
  }, [history.location.pathname]);

  const toggleModal = (bool: boolean) => {
    setVisible(bool);
    handleClickHamburger(bool);
  };

  const handleClick = async (e: any) => {
    setSelectedKey(e.key);
    setVisible(false);
    handleClickHamburger(false);
    if (e.keyPath[1] === ROUTER_PATH.CATEGORY) {
      history.push(localizeRouteKey(e.keyPath[1]) + e.key);
    } else if (
      e.keyPath[1] === ROUTER_PATH.HELP ||
      (e.keyPath[1] === "aboutKymdan" && e.key === POLICY.INTRO_COMPANY)
    ) {
      history.push(
        localizeRouteKey(ROUTER_PATH.POLICY_AND_GENERAL_TERMS) + t(e.key)
      );
    } else if (e.keyPath[1] === "account" && e.key === ROUTER_PATH.SIGN_OUT) {
      await dispatch(signOut());
    } else {
      history.push(localizeRouteKey(e.key));
    }
  };

  const handleToggleLanguage = (e: any) => {
    history.push(getMatchingRoute(pathname, e.key));
  };

  const showMenuCategories = (menus: any) =>
    menus.map((m: any) => (
      <Menu.Item key={`${t(`routes.category_${m.slug}`)}`}>{m.name}</Menu.Item>
    ));

  const showMenuHelp = (menus: any) =>
    menus.map((m: any) => {
      if (t(m.key) === selectedKey) {
        setSelectedKey(m.key);
      }

      return <Menu.Item key={m.key}>{t(m.name)}</Menu.Item>;
    });

  const footer = (
    <Row align="middle">
      <Col style={{ marginRight: 10 }}>
        <a href={`tel:${PHONE_CONTACT}`}>
          <img
            style={{ width: 50 }}
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_phone-63.svg"
          />
        </a>
      </Col>
      <Col>
        <a href={MESSENGER_URL} target="_blank">
          <img
            style={{ width: 50 }}
            src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_mes-62.svg"
          />
        </a>
      </Col>
      <Col span={14} className="back-to-kymdan">
        <a href="https://www.kymdan.com/">
          Về trang <span>kymdan.com</span>
        </a>
      </Col>
    </Row>
  );

  return (
    <Drawer
      title={<SearchBar closeModal={toggleModal} history={history} />}
      placement="left"
      closable={false}
      onClose={() => setVisible(false)}
      visible={visible}
      key="left"
      className="kd-hamburger-content"
      footer={footer}
      footerStyle={{
        height: 150,
        width: "100%",
        backgroundColor: "#f5f5f5",
        padding: "10px 5% 10px 10%",
      }}>
      <Menu
        mode="inline"
        className="menu-wrapper"
        selectedKeys={[selectedKey]}
        onClick={handleClick}>
        <SubMenu
          key={ROUTER_PATH.CATEGORY}
          title={
            <span className="main-title">{t("footer_title_product")}</span>
          }>
          {headerCategories &&
          headerCategories.header_category_id &&
          headerCategories.header_category_id.length
            ? showMenuCategories(
                _.sortBy(
                  headerCategories.header_category_id.filter(
                    (m: any) =>
                      m.is_parent && m.is_actived && m.category_ids.length
                  ),
                  ["order"]
                )
              )
            : null}
        </SubMenu>
        <SubMenu
          key="aboutKymdan"
          title={<span className="main-title">{t("about_KYMDAN")}</span>}>
          <Menu.Item key="intro_company">{t("about_kymdan")}</Menu.Item>
          <Menu.Item key={`${t(ROUTER_PATH.STORE_AGENCY)}`}>
            {t("experience_system")}
          </Menu.Item>
          <Menu.Item key={`${t(ROUTER_PATH.EVENT)}`}>{t("event")}</Menu.Item>
          <Menu.Item key={`${t(ROUTER_PATH.POLICY_AND_GENERAL_TERMS)}`}>
            {t("title_page_policy")}
          </Menu.Item>
        </SubMenu>
        <SubMenu
          key="account"
          title={<span className="main-title">{t("account")}</span>}>
          {token === null ? (
            <Menu.ItemGroup>
              <Menu.Item key={`${t(ROUTER_PATH.SIGN_IN)}`}>
                {t("title_screen_sign_in")}
              </Menu.Item>
              <Menu.Item key={`${t(ROUTER_PATH.SIGN_UP)}`}>
                {t("title_screen_sign_up")}
              </Menu.Item>
            </Menu.ItemGroup>
          ) : null}
          {token ? (
            <Menu.ItemGroup>
              <Menu.Item key={`${t(ROUTER_PATH.PROFILE)}`}>
                {t("user_information")}
              </Menu.Item>
              <Menu.Item key={`${t(ROUTER_PATH.ORDERS)}`}>
                {t("user_manager_order")}
              </Menu.Item>
              <Menu.Item key={`${t(ROUTER_PATH.PRODUCTS_WISH)}`}>
                {t("user_wish")}
              </Menu.Item>
              <Menu mode="inline" className="menu-wrapper">
                <Menu.Item key={ROUTER_PATH.SIGN_OUT}>
                  {t("btn_sign_out")}
                </Menu.Item>
              </Menu>
            </Menu.ItemGroup>
          ) : null}
        </SubMenu>
        {/* <Menu.Item key="lookUpOrder">
          <a className="main-title">{t("look_up_order")}</a>
        </Menu.Item> */}

        <SubMenu
          key={ROUTER_PATH.HELP}
          title={<span className="main-title">{t("title_page_help")}</span>}>
          {showMenuHelp(HELP_MENU)}
        </SubMenu>
      </Menu>
      <Menu
        mode="inline"
        className="menu-wrapper"
        selectedKeys={[i18n.language]}
        onClick={handleToggleLanguage}>
        <SubMenu
          key="sub5"
          title={<span className="main-title">{t("language")}</span>}>
          <Menu.Item key={APP_LANGUAGE.Vietnamese}>{t("vietnamese")}</Menu.Item>
          <Menu.Item key={APP_LANGUAGE.English}>{t("english")}</Menu.Item>
        </SubMenu>
      </Menu>
    </Drawer>
  );
};

export default forwardRef(HamburgerContent);
